<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="activityId" label="关联演出:">
                        <span slot="label">关联演出：<small>输入演出ID查询</small></span>
                        <el-select v-model="formData.activityId" @change="activityChange" filterable
                            default-first-option remote :remote-method="searchActivity" :loading="searchLoading" placeholder="请输入演出ID">
                            <el-option v-for="(item, index) in activityList" :key="index" :value="item.id"
                                :label="item.title"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="tagsId" label="关联标签:">
                        <el-select v-model="formData.tagsId" filterable clearable default-first-option>
                            <el-option v-for="item in tagsList" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="MT20">
            <el-button type="primary" @click="submitForm()">下一步</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: {
            type: Number,
            default: 0
        },
        formData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            rules: {
                activityId: [{ required: true, message: "请选择管理演出" }]
            },
            activityList: [],
            tagsList: [],
            searchLoading: false,
        }
    },
    created() {
        this.getActivityList();
    },
    methods: {
        //获取最近演出列表
        getActivityList() {
            this.searchLoading = true;
            this.$request({
                url: '/photo/latelyUpload',
                params: {},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.activityList = [...result]
                    } else {
                        this.$message.error(msg || "请求失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("请求失败,请重试");
                })
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        //获取标签列表
        getTags() {
            this.$request({
                url: "/photo/getTags",
                method: "POST",
                params: {
                    activityId: this.formData.activityId
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.tagsList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //选择演出
        activityChange() {
            this.formData.tagsId = "";
            this.getTags();
        },
        //搜索演出
        searchActivity(name) {
            if (!/^[0-9]+$/.test(name)){
                this.activityList = [];
                return;
            }
            this.searchLoading = true;
            this.$request({
                url: '/photo/activityInfo',
                params: { id: name },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.activityList = [...result]
                    } else {
                        this.$message.error(msg || "请求失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("请求失败,请重试");
                })
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        //第一步表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    // this.steps = 1;   
                    this.$emit("update:steps", 1);
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>